/**
 * @generated SignedSource<<36744c66eff1ef824bc0c15198df1508>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useRecentAgentActivity_issue$data = {
  readonly eventRationales: ReadonlyArray<{
    readonly issueEvent: {
      readonly id?: string;
    } | null | undefined;
    readonly rationale: string;
  }>;
  readonly id: string;
  readonly recentTriageEvents: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "IssueFieldAddedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly color: string | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly issueField: {
        readonly name?: string;
      } | null | undefined;
      readonly value: string | null | undefined;
    } | {
      readonly __typename: "IssueFieldChangedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly issueField: {
        readonly name?: string;
      } | null | undefined;
      readonly newColor: string | null | undefined;
      readonly newValue: string | null | undefined;
    } | {
      readonly __typename: "IssueFieldRemovedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly issueField: {
        readonly name?: string;
      } | null | undefined;
    } | {
      readonly __typename: "IssueTypeAddedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly name: string;
      } | null | undefined;
    } | {
      readonly __typename: "IssueTypeChangedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly name: string;
      } | null | undefined;
    } | {
      readonly __typename: "IssueTypeRemovedEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly issueType: {
        readonly color: IssueTypeColor;
        readonly name: string;
      } | null | undefined;
    } | {
      readonly __typename: "LabeledEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly label: {
        readonly color: string;
        readonly name: string;
      };
    } | {
      readonly __typename: "UnlabeledEvent";
      readonly actor: {
        readonly __typename: string;
        readonly avatarUrl: string;
        readonly displayName?: string;
        readonly login: string;
      } | null | undefined;
      readonly createdAt: string;
      readonly id: string;
      readonly label: {
        readonly color: string;
        readonly name: string;
      };
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly repository: {
    readonly nameWithOwner: string;
  };
  readonly viewerCanUpdateMetadata: boolean | null | undefined;
  readonly " $fragmentType": "useRecentAgentActivity_issue";
};
export type useRecentAgentActivity_issue$key = {
  readonly " $data"?: useRecentAgentActivity_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRecentAgentActivity_issue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "type": "Bot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  (v0/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Label",
    "kind": "LinkedField",
    "name": "label",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  },
  (v7/*: any*/)
],
v9 = [
  (v0/*: any*/),
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueType",
    "kind": "LinkedField",
    "name": "issueType",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": null
  },
  (v7/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/)
      ],
      "type": "IssueFieldCommon",
      "abstractKey": "__isIssueFieldCommon"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "since"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRecentAgentActivity_issue",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUpdateMetadata",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameWithOwner",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueEventRationale",
      "kind": "LinkedField",
      "name": "eventRationales",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rationale",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "issueEvent",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "LabeledEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "UnlabeledEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "IssueTypeAddedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "IssueTypeChangedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "IssueTypeRemovedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "IssueFieldChangedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "IssueFieldAddedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v1/*: any*/),
              "type": "IssueFieldRemovedEvent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "recentTriageEvents",
      "args": [
        {
          "kind": "Literal",
          "name": "itemTypes",
          "value": [
            "LABELED_EVENT",
            "UNLABELED_EVENT",
            "ISSUE_TYPE_ADDED_EVENT",
            "ISSUE_TYPE_CHANGED_EVENT",
            "ISSUE_TYPE_REMOVED_EVENT",
            "ISSUE_FIELD_CHANGED_EVENT",
            "ISSUE_FIELD_ADDED_EVENT",
            "ISSUE_FIELD_REMOVED_EVENT"
          ]
        },
        {
          "kind": "Literal",
          "name": "last",
          "value": 25
        },
        {
          "kind": "Variable",
          "name": "since",
          "variableName": "since"
        },
        {
          "kind": "Literal",
          "name": "visibleEventsOnly",
          "value": true
        }
      ],
      "concreteType": "IssueTimelineItemsConnection",
      "kind": "LinkedField",
      "name": "timelineItems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v8/*: any*/),
              "type": "LabeledEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v8/*: any*/),
              "type": "UnlabeledEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v9/*: any*/),
              "type": "IssueTypeAddedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v9/*: any*/),
              "type": "IssueTypeChangedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v9/*: any*/),
              "type": "IssueTypeRemovedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v10/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "newValue",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "newColor",
                  "storageKey": null
                },
                (v7/*: any*/)
              ],
              "type": "IssueFieldChangedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v10/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                (v5/*: any*/),
                (v7/*: any*/)
              ],
              "type": "IssueFieldAddedEvent",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v10/*: any*/),
                (v7/*: any*/)
              ],
              "type": "IssueFieldRemovedEvent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "0a6db1a7bda08b93d82febd1c7540bd9";

export default node;
